<template>
  <div class="add_main">
    <!-- <div class="step-box">
      <span class="mgr20" :class="{ stepOn: stepIndex == index }" v-for="(val, index) in stepList" :key="index"
        @click="handleStep(index)">{{ val }}</span>
    </div> -->
    <el-form v-if="stepIndex == 0" ref="goodDetailForm" :model="goodDetailForm" label-width="100px">
      <el-form-item label="商品归属：">
        <el-select v-model="goodDetailForm.sourceId" filterable placeholder="请选择供应商（可搜索）" @change="select_blur_supplier">
          <!-- @clear="clearSupplier" -->
          <el-option v-for="(item, index) in supplierList" :key="index" :label="item.proSupplierName" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="商品型号：">
        <el-input v-model="goodDetailForm.model" placeholder="请输入商品型号"></el-input>
        <!-- 
            clearable<div style="color: red;" v-if="isSearch">
            @input="getModelCode"
          * 没有匹配到素材库型号, 将以填写型号为准
        </div> -->
      </el-form-item>
      <!-- <el-form-item label="" class="modelCodeStyle" v-if="isModelListShow">
        <div class="modelStyle" v-loading="modelListLoading"
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.8)" element-loading-text="详情搜索中">
          <div @click="setCurrentIndex(item, index)" :class="{'active' : index == currentIndex}"
               style="cursor: pointer;" v-for="(item, index) in modelList" :key="index">
            型号: {{ item.modelCode }}
            <div style="margin-right: 10px; height:1px; background: #DCDFE6"></div>
          </div>
        </div>
      </el-form-item> -->
      <el-form-item label="商品类型：">
        <el-cascader v-model="goodDetailForm.categoryId" :props="{ emitPath: false }" :show-all-levels="true"
          :options="productNavTypeTreeList" placeholder="请选择类型" ref="cascaderCategory"></el-cascader>
      </el-form-item>
      <el-form-item label="商品品牌：">
        <el-autocomplete v-model="goodDetailForm.brandName" :fetch-suggestions="querySearchAsync" placeholder="请选择品牌 可搜索"
          @select="handleSelect"></el-autocomplete>
      </el-form-item>
      <el-form-item label="商品名称：">
        <el-input v-model="goodDetailForm.name" placeholder="请输入商品名称"></el-input>
      </el-form-item>
      <el-form-item label="商品图片：" style="margin-bottom: 50px">
        <draggable :list="goodDetailForm.pictures" :group="{ sort: true, animation: 500 }">
          <div class="img_box" v-for="(item, index) in goodDetailForm.pictures" :key="index">
            <p class="del_box" @click.stop="handleDelPic(item, index)">
              <img src="../../../assets/del-icon.png" alt />
            </p>
            <img :src="item.url" alt @click.stop="handleBigPic(item.url)" />
            <p class="set_main">
              <el-button size="mini" @click.stop="setMain(item, index)">{{
                item.type == 0 ? "主图" : "设为主图"
              }}
              </el-button>
            </p>
          </div>
          <span style="color:#f40000;position: absolute;bottom:0;" v-if="isShowNinePic">最多添加9张</span>
          <el-upload v-if="!isShowNinePic" class="img-uploader" action :show-file-list="false" :auto-upload="false"
            :on-change="handleBusinessPic" multiple>
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </draggable>
      </el-form-item>
      <el-form-item label="商品描述：" style="margin-top: 50px">
        <weditor @catchData="catchDetailData" :isAddEditor="true" v-model="goodDetailForm.introduce"
          :content="goodDetailForm.introduce" :editorHeight="500"></weditor>
      </el-form-item>
      <el-form-item label="补充说明：">
        <el-input type="textarea" v-model="goodDetailForm.serviceContent"
          placeholder="例如：正品保障、7天无理由退换货、15天换货，多个请使用中文顿号分隔"></el-input>
      </el-form-item>
      <el-form-item>
        <div style="text-align:center;">
          <el-button type="primary" v-preventClick @click="addOrUpdata(false)">下一步</el-button>
        </div>
      </el-form-item>
    </el-form>
    <!-- 设置发货库存 -->
    <el-form v-if="stepIndex == 1">
      <el-form-item label="商品规格"
        v-if="goodDetailForm.propertyGroupId == 0 || goodDetailForm.propertyGroupId == 124 || goodDetailForm.propertyGroupId == 125">
        <el-radio-group v-model="radioSpec" @change="specTemplate" :disabled="radioDisabled">
          <el-radio :label="1">单规格</el-radio>
          <el-radio :label="2">多规格</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="radioSpec == 1">
        <el-table id="allsku" border :data="editSkuList1" :row-class-name="(value) => rowClassName(value)">
          <el-table-column label="规格名称" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.propertyValueExtString" placeholder="请输入"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="规格图" align="center">
            <template slot-scope="scope">
              <div class="cell up_img">
                <div class="el_upload_sku">
                  <input class="el_upload_input" @change="handleSkuChange($event, scope.row)" id="el_upload_input"
                    type="file" />
                  <img v-if="scope.row.pictureUrl" :src="scope.row.pictureUrl" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <span class="mask" v-if="scope.row.pictureUrl" @click.stop="delSkuPic(scope.row)">
                    <i class="el-icon-delete"></i>
                  </span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="商品编码(选填)" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.productCode" placeholder="请输入"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="限购区域" align="center">
            <template slot-scope="scope">
              <div class="flex-wrap">
                <el-select style="width:100%" v-model="scope.row.restrictionAreaGroupId" placeholder="请选择">
                  <el-option :value="0" label="不限购"></el-option>
                  <el-option v-for="(item, index) in areaGroupList" :key="index" :label="item.name"
                    :value="item.id"></el-option>
                </el-select>
                <el-button type="primary" @click="renderAreaTree(scope.$index)">添加模板</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="" align="center">
            <template slot="header" slot-scope="scope">
              <el-button type="primary" icon="el-icon-plus" @click="addSpec1">添加规格</el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text" @click="deleteSpec1(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item v-if="radioSpec == 2">
        <el-table id="allsku" border :data="allSkuList" :span-method="objectSpanMethod"
          :header-cell-class-name="headerClassName" :row-class-name="(value) => rowClassName(value)">
          <el-table-column label="属性名称" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.propertyValueExtString" placeholder="请输入"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="" align="center">
            <template slot-scope="scope">
              <el-table id="allsku" style="border-color:#EBEEF5;" :data="scope.row.children"
                :row-class-name="(value) => rowClassName(value)">
                <el-table-column label="规格名称" align="center">
                  <template slot-scope="scoped">
                    <div class="flex-wrap">
                      <span style="min-width:30px">{{ scoped.row.propertyValueId }}</span>
                      <el-input v-model="scoped.row.propertyValueExtString" placeholder="请输入"
                        @change="(value) => changeInput(value, scoped.row)"></el-input>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="规格图" align="center">
                  <template slot-scope="scoped">
                    <div class="cell up_img">
                      <div class="el_upload_sku">
                        <input class="el_upload_input" @change="handleSkuChange($event, scoped.row)" id="el_upload_input"
                          type="file" />
                        <img v-if="scoped.row.pictureUrl" :src="scoped.row.pictureUrl" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        <span class="mask" v-if="scoped.row.pictureUrl" @click.stop="delSkuPic(scoped.row)">
                          <i class="el-icon-delete"></i>
                        </span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="商品编码(选填)" align="center">
                  <template slot-scope="scoped">
                    <el-input v-model="scoped.row.productCode" placeholder="请输入"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="限购区域" align="center">
                  <template slot-scope="scoped">
                    <div class="flex-wrap">
                      <el-select v-model="scoped.row.restrictionAreaGroupId" placeholder="请选择限购模板">
                        <el-option :value="0" label="不限购"></el-option>
                        <el-option v-for="(item, index) in areaGroupList" :key="index" :label="item.name"
                          :value="item.id"></el-option>
                      </el-select>
                      <el-button type="primary" @click="renderAreaTree(scope.$index, scoped.$index)">添加模板</el-button>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="" align="center">
                  <template slot="header" slot-scope="scoped">
                    <el-button type="primary" icon="el-icon-plus" @click="addSpec2(scope.row)">添加规格</el-button>
                  </template>
                  <template slot-scope="scoped">
                    <el-button type="text" @click="deleteSpec2(scoped.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="" align="center"></el-table-column>
          <el-table-column label="" align="center"></el-table-column>
          <el-table-column label="" align="center"></el-table-column>
          <el-table-column label="" align="center"></el-table-column>
          <el-table-column label="" align="center" width="55">
            <template slot-scope="scope">
              <el-button type="text" style="font-size:29px;" icon="el-icon-remove-outline"
                @click="deleteProperty(scope.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align:center;font-size:24px;cursor: pointer;margin-top:20px;">
          <i style="color:#3B6FFA;" class="el-icon-circle-plus-outline"></i><span @click="addProperty">添加新属性</span>
        </div>
      </el-form-item>
      <el-form-item>
        <div style="text-align:center;">
          <el-button type="primary" @click="nextStep()">下一步</el-button>
        </div>
      </el-form-item>
    </el-form>
    <!-- 设置库存与价格 -->
    <el-form v-if="stepIndex == 2">
      <el-form-item>
        <el-table border :data="saleableSkuList" :span-method="objectSpanMethod2">
          <el-table-column label="分销商名称" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.resellerId" placeholder="请选择" clearable @clear="clearSelect(scope.$index)"
                @change="(val) => changeReseller(val, scope.$index)" disabled>
                <el-option v-for="(item, index) in resellerList" :key="index" :label="item.name"
                  :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column label="规格名称" align="center">
            <template slot-scope="scope">
              <el-checkbox v-model="scope.row.checked" disabled>{{ scope.row.propertyDisplayExt }}</el-checkbox>
            </template>
          </el-table-column>
          <el-table-column label="供货价" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.supplyPrice" placeholder="请输入"></el-input>
            </template>
          </el-table-column>
          <!--  <el-table-column label="商家价" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.merchantsPrice" v-if="scope.row.priceType == 1" disabled
                placeholder="请输入"></el-input>
             <el-input v-model="scope.row.merchantsPrice" v-else placeholder="请输入"></el-input>
            </template>
          </el-table-column> -->
          <el-table-column label="零售价" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.retailPrice" v-if="scope.row.priceType == 1" disabled
                placeholder="请输入"></el-input>
              <el-input v-model="scope.row.retailPrice" v-else placeholder="请输入"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="市场价" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.marketPrice" v-if="scope.row.priceType == 1" disabled
                placeholder="请输入"></el-input>
              <el-input v-model="scope.row.marketPrice" v-else placeholder="请输入"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="销售库存" align="center">
            <template slot-scope="scope">
              <el-input v-model="scope.row.defaultStock" placeholder="请输入"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="区域库存" align="center">
            <template slot-scope="scope">
              <el-button @click="setZone(scope.row, scope.$index)">设置</el-button>
            </template>
          </el-table-column>
          <!-- <el-table-column label="" align="center">
            <template slot="header" slot-scope="scope">
              <el-button type="primary" icon="el-icon-plus" @click="addReseller()">添加分销商</el-button>
            </template>
            <template slot-scope="scope">
              <el-button type="text" @click="deleteReseller(scope.$index)">删除</el-button>
            </template>
          </el-table-column> -->
        </el-table>
      </el-form-item>
      <!-- <el-form-item> -->
      <div style="text-align:center;">
        <!--     <el-button type="primary" @click="saveReseller(false)">保存信息</el-button> -->
        <el-button type="primary" @click="saveReseller(true)">上架并同步</el-button>
      </div>
      <!-- </el-form-item> -->
    </el-form>
    <!-- 图片放大 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" height="100%" :src="dialogImageUrl" alt />
    </el-dialog>
    <!-- 区域限购配置 -->
    <el-dialog id="areaSet" title="区域限购配置" append-to-body :visible.sync="areaSetFormVisible" v-if="areaSetFormVisible"
      v-model="areaSetFormVisible" :close-on-click-modal="false" width="50%">
      <el-form>
        <el-form-item label="模板名称" label-width="80px">
          <el-input v-model="formTemplate.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-tree style="height:400px;overflow:auto;" :data="areaTreeList" show-checkbox node-key="id" ref="tree"
            highlight-current>
          </el-tree>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="areaSetFormVisible = false, areaList = []">取消</el-button>
        <el-button type="primary" @click.native="submitAreaSet">提交</el-button>
      </div>
    </el-dialog>
    <!-- 区域库存设置 -->
    <el-dialog append-to-body title="区域库存设置" :visible.sync="zoneVisible" width="50%">
      <div style="margin-bottom:20px;">
        <el-input v-model="configData" clearable size="small" style="width: 200px;margin-right:20px;"
          placeholder="请输入配置信息"></el-input>
        <el-button type="primary" @click="setConfig" size="small">一键配置</el-button>
        <el-button type="primary" @click="clearConfig" size="small">清空配置</el-button>
        <el-button type="primary" @click="toggleRowExpansion" size="small">全部{{
          isExpansion ? '收缩' : '展开'
        }}
        </el-button>
      </div>
      <div style="height:60vh;overflow-y:auto;">
        <el-table ref="topicTable" :data="zoneData" style="width: 100%;margin-bottom: 20px;" row-key="id" border
          default-expand-all :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
          <el-table-column prop="areaName" label="省市">
          </el-table-column>
          <el-table-column label="库存">
            <template slot-scope="scope">
              <input type="number" :disabled="scope.row.disabled" v-model="scope.row.stock"
                style="height:35px;padding:0 5px;border:1px solid #eee;border-radius:5px;">
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="zoneVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleUpdateSaleArea">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 错误提示 -->
    <el-dialog title="提示" :visible.sync="errVisible" width="30%" :before-close="handleClose">
      <div v-html="errHtml"></div>
    </el-dialog>
  </div>
</template>

<script>
import {
  ProductCreate, //上传商品
  getQiniuToken,
  CategoryGetTree, //获取商品类型
  brandGetAll, //品牌列表
  PropertyGroupGetAll,
  GetProductSkuPreView,
  GetProducDetail,
  BatchCreateAndUpdate,
  ProductSkuGetAllNew,
  ProductSkuDelete,
  ProductUpdate, //商品编辑
  GetAllProperties,
  AddPicture,
  DeletePicture,
  UpdatePicture,
  GetAllSupplier,
  GetAreaTree,
  RestrictionAreaGroupGetAll,
  ProductSkuGetMany,
  PropertyGroupTree,
  ProductGetTree,
  SaleableSkuGetMany,
  ProductSkuCreateMany,
  CreateOrUpdateMany,
  GetAllReseller,
  GetSaleableAreas,
  RestrictionAreaGroupCreate,
  GetProhibitedList
} from "../../../api/api";
import draggable from "vuedraggable";
import weditor from "../../../components/WangEditor";
import { getButtonList } from "../../../promissionRouter";
// import maintain from "./components/maintain.vue"

export default {
  components: {
    weditor,
    draggable,
    // maintain,
  },
  watch: {
    // "goodDetailForm.categoryId": {
    //   handler(n, o) {
    //     this.getPropertyList(n)
    //   },
    //   deep: true
    // },
    "goodDetailForm.propertyGroupId": {
      handler(n, o) {
        // this.getAllProperties(n)
      },
      deep: true
    },
    "goodDetailForm.pictures": {
      handler(n, o) {
        if (n.length) {
          this.skuMainpic = n[n.findIndex(val => val.type == 0)].url
        }
        if (n.length >= 9) {
          this.isShowNinePic = true
        } else {
          this.isShowNinePic = false
        }
      },
      deep: true
    }
  },
  data() {
    return {
      stepIndex: 2,
      stepList: ['商品信息', '发货库存', '库存与价格'],
      isShowNinePic: false, // 最多显示图片
      dialogMaintain: false,
      dialogCombination: false, // 属性组合展示
      spuId: null,
      qiniuToken: "",
      brandList: [], // 品牌列表
      goodDetailForm: {
        categoryId: null,
        categorys: [],
        name: null, //商品名称
        model: null, //型号
        brandId: null, //商品品牌
        brandName: '',
        order: null,
        serviceContent: '',
        introduce: '',
        isActive: true,
        pictures: [],
        propertyGroupId: null,
        propertyGroupName: '',
        properties: [],
        sourceType: null,
        sourceId: null
      },
      propertyList: [], // 属性模板
      skuPreViewList: [], // 规格组合
      checkedSkuList: [],
      productNavTypeTreeList: [], //商品类型
      createSkuList: [], //规格最终生成的数组
      dialogVisible: false,
      dialogImageUrl: "",
      checkList: [],
      supplierList: [],

      categoryId: 0,
      resList: [],
      skuMainpic: null,

      radioDisabled: true,
      radioSpec: 1,
      skuNum: 3,
      editSkuList1: [], // 单规格sku数组
      editSkuList2: [],
      allSkuList: [],
      propertySku: [],
      propertySku_n: [],
      areaSetFormVisible: false,
      areaTreeList: [],
      skuIndex: -1,
      skuChildIndex: -1,
      areaGroupList: [],
      saleableSkuList: [],
      skuInfoNum: 0,
      resellerList: [],
      zoneVisible: false,
      zoneData: [],
      baseAreaList: [], // 后台返回的未格式化的基础区域数据
      alreadySetArae: [],
      saleableSkuIndex: -1,
      formTemplate: {
        name: null,
        isActive: true,
        restrictionAreas: []
      },
      configData: null,
      isExpansion: true,
      errVisible: false,
      errHtml: ''
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log(to, from, '路由')
  //   if (from.path == "/Product/AttributeTemplate/Maintain") {
  //     to.meta.keepAlive = true;
  //   } else {
  //     to.meta.keepAlive = false;
  //   }
  //   next();
  // },
  created() {

  },
  mounted() {

  },
  methods: {
    initData(spuId) {
      this.spuId = spuId
      this.getSupplierList();
      this.getQiniuToken();
      this.getProductNavTypeTree();
      this.getBrandList();
      this.getAreaGroupList()
      this.getAllReseller()
      this.getSpuDetail()
      this.getProductSkuGetMany()
    },
    setConfig() {
      if (!this.configData) {
        return this.$message.error('请输入配置信息')
      }
      this.setData()
    },
    clearConfig() {
      this.configData = null;
      this.setData();
    },
    setData() {
      let tempData = this.zoneData;
      tempData.forEach(item => {
        item.stock = this.configData ? this.configData : null;
        if (item.children) {
          item.children.forEach(item => {
            item.stock = this.configData ? this.configData : null;
          })
        }
      })
      this.zoneData = tempData;
    },
    toggleRowExpansion() {
      this.isExpansion = !this.isExpansion
      this.toggleRowExpansion_forAll(this.zoneData, this.isExpansion);
    },
    toggleRowExpansion_forAll(data, isExpansion) {
      data.forEach(item => {
        this.$refs.topicTable.toggleRowExpansion(item, isExpansion);
        if (item.children != undefined && item.children != null) {
          this.toggleRowExpansion_forAll(item.children, isExpansion);
        }
      })
    },
    changeInput(value, row) {
      this.allSkuList.forEach(item => {
        item.children.forEach(val => {
          if (val.propertyValueId == row.propertyValueId) {
            val.propertyValueExtString = value
          }
        })
      })
    },
    handleStep(i) {
      this.stepIndex = i
    },
    addSpec1() {
      let index = this.editSkuList1.findIndex(item => {
        return !item.isShow
      })
      this.propertySku.forEach(item => {
        item.restrictionAreaGroupId = 0
        item.restrictionAreaItems = []
      })
      if (this.editSkuList1.length == this.propertySku.length) {
        // 两数组长度相等，此时模板内容全部选中，只做页面操作
        if (index > -1) {
          this.editSkuList1[index].isShow = true
        }
      } else if (this.editSkuList1.length < this.propertySku.length) {
        // children中有未选中的，使其选中；全选之后，从groupChildren做对比添加
        if (index == -1) {
          let flag = this.propertySku.filter(item => {
            return this.editSkuList1.every(val => {
              return val.propertyValueId != item.propertyValueId
            })
          })
          let obj = flag[0]
          obj.pictureUrl = this.skuMainpic
          this.editSkuList1.push({ ...obj })
          // if (flag.length>1) {
          //   this.editSkuList1.push(flag[0])
          // } else {
          //   this.editSkuList1 = this.editSkuList1.concat(flag)
          // }
        } else {
          this.editSkuList1[index].isShow = true
        }
      }
    },
    deleteSpec1(row) {
      row.isShow = false
    },
    addProperty() {
      let index = this.allSkuList.findIndex(item => {
        return !item.isShow
      })
      if (this.allSkuList.length == this.propertySku.length) {
        if (index > -1) {
          this.allSkuList[index].isShow = true
        }
      } else if (this.allSkuList.length < this.propertySku.length) {
        if (index == -1) {
          let obj = { ...this.propertySku[this.allSkuList.length] }
          obj.children = [...this.allSkuList[this.allSkuList.length - 1].children]
          this.allSkuList.push({ ...obj })
        } else {
          this.allSkuList[index].isShow = true
        }
      }
      // console.log(this.allSkuList,'this.allSkuList')
    },
    deleteProperty(row) {
      row.isShow = false
    },
    addSpec2(row) {
      let { children } = row
      let groupChildren = this.propertySku[0].children
      groupChildren.forEach(item => {
        item.restrictionAreaGroupId = 0
        item.restrictionAreaItems = []
      })
      let index = children.findIndex(item => {
        return !item.isShow
      })
      if (children.length == groupChildren.length) {
        // 两数组长度相等，此时模板内容全部选中，只做页面操作
        if (index > -1) {
          children[index].isShow = true
        }
      } else if (children.length < groupChildren.length) {
        // children中有未选中的，使其选中；全选之后，从groupChildren做对比添加
        if (index == -1) {
          // children.push(groupChildren[children.length])
          let flag = groupChildren.filter(item => {
            return children.every(val => {
              return val.propertyValueId != item.propertyValueId
            })
          })
          let obj = flag[0]
          obj.pictureUrl = this.skuMainpic
          children.push({ ...obj })
        } else {
          children[index].isShow = true
        }
      }
      console.log(groupChildren, children, 'groupChildren')
    },
    deleteSpec2(row) {
      row.isShow = false
    },
    // sku信息提交处理
    handleSkuinfo1(arr) {
      let list = arr.filter(item => {
        return item.isShow
      })
      let flage = list.every(item => {
        return item.propertyValueExtString && item.pictureUrl
      })
      if (!flage) {
        return this.$message.error('以上数据都为必填,还有数据未填,请填写!')
      }
      let items = []
      list.forEach(item => {
        let propertyList1 = [], propertyList2 = []
        propertyList1 = [{
          propertyId: item.propertyId,
          propertyString: item.propertyString,
          propertyValueId: item.propertyValueId,
          propertyValueString: item.propertyValueString
        }]
        propertyList2 = [{
          propertyId: item.propertyId,
          propertyString: item.propertyString,
          propertyValueId: item.propertyValueId,
          propertyValueString: item.propertyValueExtString
        }]
        items.push({
          propertyCode: item.propertyCode,
          productCode: item.productCode,
          pictureUrl: item.pictureUrl,
          restrictionAreaGroupId: item.restrictionAreaGroupId,
          restrictionAreaItems: item.restrictionAreaItems,
          properties: {
            propertyList: propertyList1
          },
          propertiesExt: {
            propertyList: propertyList2
          }
        })
      })
      return items
    },
    allSkuListFilter(list) {
      return list.filter(item => {
        item.children = this.allSkuListFilter(item.children)
        return item.isShow
      })
    },
    allSkuListFlage(list) {
      let flage = false
      flage = list.every(item => {
        item.flage = item.children.every(val => {
          return val.propertyValueExtString && val.pictureUrl
        })
        return item.propertyValueExtString && item.flage
      })
      return flage
    },
    handleSkuinfo2(arr) {
      let list = this.allSkuListFilter(arr)
      let flage = this.allSkuListFlage(list)
      if (!flage) {
        return this.$message.error('以上数据都为必填,还有数据未填,请填写!')
      }
      let items = []
      list.forEach(item => {
        item.children.forEach(val => {
          let propertyList1 = [], propertyList2 = []
          propertyList1 = [{
            propertyId: item.propertyId,
            propertyString: item.propertyString,
            propertyValueId: item.propertyValueId,
            propertyValueString: item.propertyValueString
          }, {
            propertyId: val.propertyId,
            propertyString: val.propertyString,
            propertyValueId: val.propertyValueId,
            propertyValueString: val.propertyValueString
          }]
          propertyList2 = [{
            propertyId: item.propertyId,
            propertyString: item.propertyString,
            propertyValueId: item.propertyValueId,
            propertyValueString: item.propertyValueExtString
          }, {
            propertyId: val.propertyId,
            propertyString: val.propertyString,
            propertyValueId: val.propertyValueId,
            propertyValueString: val.propertyValueExtString
          }]
          items.push({
            propertyCode: val.propertyCode,
            productCode: val.productCode,
            pictureUrl: val.pictureUrl,
            restrictionAreaGroupId: val.restrictionAreaGroupId,
            restrictionAreaItems: val.restrictionAreaItems,
            properties: {
              propertyList: propertyList1
            },
            propertiesExt: {
              propertyList: propertyList2
            }
          })
        })
      })
      return items
    },
    // 提交sku
    nextStep() {
      let data = {
        productId: this.spuId,
        propertyGroupId: this.goodDetailForm.propertyGroupId ? this.goodDetailForm.propertyGroupId : this.radioSpec == 1 ? 125 : 124,
        items: this.radioSpec == 1 ? this.handleSkuinfo1(this.editSkuList1) : this.handleSkuinfo2(this.allSkuList)
      }
      if (this.skuInfoNum > 0 && this.goodDetailForm.propertyGroupId == 0) {
        data.propertyGroupId = 0
      }
      // console.log(data,'nextStep')
      // return false
      ProductSkuCreateMany(data).then(res => {
        if (res.data.success) {
          this.stepIndex = 2
          // if (this.saleableSkuList.length<1) {
          ProductSkuGetMany({ productId: this.spuId }).then(res => {
            this.skuInfoNum = res.data.result.length
            // let list = res.data.result
            // list.forEach(item => {
            //   if (item.restrictionAreas.length>0) {
            //     item.restrictionAreas.forEach(val => {
            //       val.stock = 0
            //       val.areaGroupId = item.restrictionAreaGroupId
            //     })
            //   }
            // })
            // this.editSkuList2 = list
            this.editSkuList2 = res.data.result
            this.getResellerSku()
          })
          // }
        }
      })
    },
    specTemplate() {
      this.editSkuList1 = []
      this.allSkuList = []
      this.getPropertyList()
    },
    allSelArea() {
      this.$refs.tree.setCheckedNodes(this.areaTreeList);
    },
    clearSelArea() {
      this.$refs.tree.setCheckedNodes([]);
    },
    defaultChecked(keys) { // 默认选中
      this.$nextTick(() => {
        const arr = []
        keys.forEach(key => {
          if (!this.$refs.tree.getNode(key).childNodes || !this.$refs.tree.getNode(key).childNodes.length) {
            arr.push(key)
          }
        })
        this.$refs.tree.setCheckedKeys(arr)
      })
    },
    renderAreaTree(index, i) {
      this.skuIndex = index
      this.skuChildIndex = i
      this.areaSetFormVisible = true
      this.formTemplate = {
        name: null,
        isActive: true,
        restrictionAreas: []
      }
      let params = {
        MaxLevel: 2
      };
      GetAreaTree(params).then((res) => {
        this.areaTreeList = this.loopTree(res.data.result.children);
        return false
        if (this.radioSpec == 1) {
          let checkdKeys = [];
          this.editSkuList1[index].restrictionAreaItems.forEach(x => {
            checkdKeys.push(x.areaId);
          })
          this.defaultChecked(checkdKeys)
        }
        if (this.radioSpec == 2) {
          let checkdKeys = [];
          this.allSkuList[index].children[i].restrictionAreaItems.forEach(x => {
            checkdKeys.push(x.areaId);
          })
          this.defaultChecked(checkdKeys)
        }
      });
    },
    loopTree(treeList, lastFullId) {
      const newList = treeList.filter(item => {
        let Level = item.data.Level;
        item.Level = Level;
        item.areaId = item.data.Id;
        item.areaName = item.data.Name;
        item.id = item.data.Id;
        item.label = item.data.Name;
        let nowFullId;
        if (Level == 1) nowFullId = '' + item.data.Id;
        if (Level == 2) nowFullId = [item.data.ParentId, item.data.Id].join(",");
        if (Level == 3) nowFullId = lastFullId + ',' + item.data.Id;
        item.areaFullId = nowFullId;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopTree(item.children, item.areaFullId)
        }
        return true;
      })
      return newList;
    },
    submitAreaSet() {
      let checkedNodes = this.$refs.tree.getCheckedNodes(false, true);
      var newObject = JSON.parse(JSON.stringify(checkedNodes));
      newObject.forEach(x => {
        if (x.children) {
          delete x.children
        }
      })
      this.formTemplate.restrictionAreas = newObject
      RestrictionAreaGroupCreate(this.formTemplate).then((res) => {
        if (res.data.success) {
          this.$message.success('提交成功');
          this.areaSetFormVisible = false;
          this.getAreaGroupList()
        } else {
          this.$message.error(res.data.msg);
        }
      });
      // console.log(newObject,'newObject')
      return false
      console.log(this.skuIndex, this.skuChildIndex, 'this.skuChildIndex')
      if (this.radioSpec == 1) {
        this.editSkuList1[this.skuIndex].restrictionAreaItems = newObject
      } else {
        this.allSkuList[this.skuIndex].children[this.skuChildIndex].restrictionAreaItems = newObject
      }
      this.areaSetFormVisible = false;
    },
    // 获取sku信息
    getProductSkuGetMany() {
      let data = {
        productId: this.spuId
      }
      ProductSkuGetMany(data).then(res => {
        if (res.data.success) {
          this.skuInfoNum = res.data.result.length
          this.editSkuList2 = res.data.result
          // this.editSkuList2.forEach(item => {
          //   if (item.restrictionAreas.length>0) {
          //     item.restrictionAreas.forEach(val => {
          //       val.stock = 0
          //       val.areaGroupId = item.restrictionAreaGroupId
          //     })
          //   }
          // })
          if (this.skuInfoNum) {
            this.radioDisabled = true
            this.getProductGetTree()
            // return false
          } else {
            this.radioDisabled = false
            this.getPropertyList()
          }
        }
      })
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 1) {
        return [1, 5];
      } else if (columnIndex === 2) {
        return [0, 0];
      } else if (columnIndex === 3) {
        return [0, 0];
      } else if (columnIndex === 4) {
        return [0, 0];
      } else if (columnIndex === 5) {
        return [0, 0];
      }
    },
    objectSpanMethod2({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 || columnIndex === 8) {
        if (rowIndex % this.skuInfoNum === 0) {
          return {
            rowspan: this.skuInfoNum,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    rowClassName(value) {
      let { row, rowIndex } = value
      if (!row.isShow) {
        return 'showRow'
      }
    },
    // 限购区域模板
    getAreaGroupList() {
      let data = {
        isActive: true,
        skipCount: 0,
        maxResultCount: 100
      }
      RestrictionAreaGroupGetAll(data).then(res => {
        if (res.data.success) {
          this.areaGroupList = res.data.result.items
        }
      })
    },
    // 获取sku模板
    getPropertyList() {
      let data = {
        type: this.goodDetailForm.propertyGroupId ? this.goodDetailForm.propertyGroupId : this.radioSpec == 1 ? 125 : 124
      }
      PropertyGroupTree(data).then(res => {
        if (res.data.success) {
          this.radioSpec = this.getMaxlevel(res.data.result)
          this.propertySku = res.data.result
          this.setSkuData()
          this.getResellerSku()
        }
      })
    },
    getProductGetTree() {
      ProductGetTree({ id: this.spuId }).then(res => {
        if (res.data.success) {
          this.radioSpec = this.getMaxlevel(res.data.result)
          this.propertySku = res.data.result
          this.setSkuData()
          this.getResellerSku()
        } else {
          this.setSkuData()
          this.getResellerSku()
        }
      })
    },
    getMaxlevel(treeData) {
      let maxLevel = 0
      function loop(data, level) {
        data.forEach(item => {
          item.level = level
          if (level > maxLevel) {
            maxLevel = level
          }
          if ('children' in item) {
            if (item.children.length > 0) {
              loop(item.children, level + 1)
            }
          }
        })
      }
      loop(treeData, 1)
      // console.log(maxLevel,'maxLevel')
      return maxLevel
    },
    // 处理sku数据格式
    setSkuData() {
      if (this.skuInfoNum > 0) {
        // 大于0已有sku信息
        let list = []
        if (this.radioSpec == 1) {
          this.propertySku.forEach(val => {
            this.editSkuList2.forEach(item => {
              if (item.propertyCode == val.propertyCode) {
                list.push({
                  propertyCode: val.propertyCode,
                  isShow: true,
                  propertyId: val.propertyId,
                  propertyString: val.propertyString,
                  propertyValueId: val.propertyValueId,
                  propertyValueString: val.propertyValueString,
                  propertyValueExtString: item.propertyJsonExt ? JSON.parse(item.propertyJsonExt).PropertyList[0].PropertyValueString : item.propertyJson ? JSON.parse(item.propertyJson).PropertyList[0].PropertyValueString : null,
                  pictureUrl: item.pictureUrl,
                  productCode: item.productCode,
                  restrictionAreaGroupId: item.restrictionAreaGroupId,
                  restrictionAreaItems: item.restrictionAreas
                })
              }
            })
          })
          // console.log(list,'this.editSkuList1')
          this.editSkuList1 = list
        } else {
          let data = []
          let propertyCodeArr = []
          this.editSkuList2.forEach(item1 => {
            propertyCodeArr.push(item1.propertyCode)
          });
          this.propertySku.forEach((item, index) => {
            data.push({
              ...item, children: []
            })
            item.children.forEach((itemC, indexC) => {
              if (propertyCodeArr.includes(itemC.propertyCode)) {
                let obj = {}
                this.editSkuList2.forEach(item1 => {
                  if (item1.propertyCode === itemC.propertyCode) {
                    obj = item1
                  }
                })
                data[index].children.push({
                  ...itemC,
                  pictureUrl: obj.pictureUrl,
                  productCode: obj.productCode,
                  restrictionAreaItems: obj.restrictionAreas,
                  restrictionAreaGroupId: obj.restrictionAreaGroupId,
                  propertyValueExtString: obj.propertyJsonExt ? JSON.parse(obj.propertyJsonExt).PropertyList[1].PropertyValueString : obj.propertyJson ? JSON.parse(obj.propertyJson).PropertyList[1].PropertyValueString : null
                })
                data[index].propertyValueExtString = obj.propertyJsonExt ? JSON.parse(obj.propertyJsonExt).PropertyList[0].PropertyValueString : obj.propertyJson ? JSON.parse(obj.propertyJson).PropertyList[0].PropertyValueString : null
              }
            })
          })
          this.allSkuList = this.deepfilter(data)
          // console.log(data,'this.allSkuList')
        }
      } else {
        let obj = { ...this.propertySku[0] }
        let data = {
          propertyValueExtString: null,
          pictureUrl: this.skuMainpic,
          productCode: null,
          restrictionAreaGroupId: 0,
          restrictionAreaItems: [],
        }
        if (this.radioSpec == 1) {
          let data1 = {}
          data1 = Object.assign(data, obj)
          this.editSkuList1.push(data1)
        }
        if (this.radioSpec == 2) {
          let data2 = { ...this.propertySku[0].children[0] }
          data = Object.assign(data, data2)
          obj.children = [data]
          this.allSkuList.push(obj)
        }
      }
    },
    deepfilter(list) {
      return list.filter(item => {
        item.children = this.deepfilter(item.children)
        return item.propertyValueExtString
      })
    },
    // 获取分销商数据
    getResellerSku() {
      this.saleableSkuList = []
      let data = {
        productId: this.spuId
      }
      SaleableSkuGetMany(data).then(res => {
        if (res.data.success) {
          if (res.data.result.length) {
            let num = []
            res.data.result.forEach(item => {
              item.checked = false
              num.push({
                resellerId: item.resellerId,
                priceType: item.priceType,
                sysResellerId: item.sysResellerId
              })
            })
            let checklist = res.data.result
            let map = new Map()
            let reseller = num.filter((item) => !map.has(item.resellerId) && map.set(item.resellerId, item))
            let saleList = []
            this.editSkuList2.forEach(item => {
              saleList.push({
                checked: false,
                resellerId: null,
                priceType: 0,
                sysResellerId: 0,
                propertyDisplayExt: item.propertyDisplayExt,
                productId: item.productId,
                productSkuId: item.id,
                supplyPrice: null,
                retailPrice: null,
                merchantsPrice: null,
                marketPrice: null,
                defaultStock: null,
                isShelves: true,
                // saleableAreas: []
                saleableAreas: item.restrictionAreas
              })
            })
            reseller.forEach(item => {
              saleList.forEach(val => {
                val.resellerId = item.resellerId
                val.priceType = item.priceType
                val.sysResellerId = item.sysResellerId
                this.saleableSkuList.push({ ...val })
              })
            })
            this.saleableSkuList.forEach(item => {
              checklist.forEach(val => {
                if (val.productSkuId == item.productSkuId && val.resellerId == item.resellerId) {
                  item.checked = true,
                    item.saleableSkuId = val.id
                  item.supplyPrice = val.supplyPrice,
                    item.retailPrice = val.retailPrice,
                    item.merchantsPrice = val.merchantsPrice,
                    item.marketPrice = val.marketPrice,
                    item.defaultStock = val.defaultStock,
                    item.isShelves = val.isShelves,
                    item.saleableAreas = val.saleableAreas.length ? val.saleableAreas : item.saleableAreas
                }
              })
            })
            this.objArr = JSON.parse(JSON.stringify(this.saleableSkuList))
            console.log(this.saleableSkuList, 'this.saleableSkuList')
          }
        }
      })
    },
    addReseller() {
      this.editSkuList2.forEach(item => {
        this.saleableSkuList.push({
          checked: true,
          propertyDisplayExt: item.propertyDisplayExt,
          resellerId: null,
          priceType: 0,
          sysResellerId: 0,
          productId: item.productId,
          productSkuId: item.id,
          supplyPrice: null,
          retailPrice: null,
          merchantsPrice: null,
          marketPrice: null,
          defaultStock: null,
          isShelves: false,
          saleableAreas: item.restrictionAreas
        })
      })
      this.objArr = JSON.parse(JSON.stringify(this.saleableSkuList))
      // console.log(this.saleableSkuList,'this.saleableSkuList')
    },
    deleteReseller(index) {
      this.saleableSkuList.splice(index, this.skuInfoNum)
      this.objArr = JSON.parse(JSON.stringify(this.saleableSkuList))
    },
    getAllReseller() {
      let data = {
        SkipCount: 0,
        MaxResultCount: 100
      }
      GetAllReseller(data).then(res => {
        if (res.data.success) {
          this.resellerList = res.data.result.items
          this.resellerList.forEach(item => {
            item.disabled = false
          })
        }
      })
    },
    clearSelect(index) {
      let num = index + this.skuInfoNum
      for (let i = index; i < num; i++) {
        this.saleableSkuList[i].resellerId = null
        this.saleableSkuList[i].priceType = 0
        this.saleableSkuList[i].sysResellerId = 0
      }
      this.objArr = JSON.parse(JSON.stringify(this.saleableSkuList))
    },
    changeReseller(val, index) {
      if (!val) { return false }
      let num = index + this.skuInfoNum
      let resellerInfo = this.resellerList.filter(v => {
        return v.id == val
      })[0]
      let flage = this.objArr.filter(item => {
        return item.sysResellerId == resellerInfo.sysResellerId
      })
      let target = this.objArr[index]
      if (target.sysResellerId == resellerInfo.sysResellerId && target.resellerId != resellerInfo.resellerId) {
        for (let i = index; i < num; i++) {
          this.saleableSkuList[i].resellerId = val
          this.saleableSkuList[i].priceType = resellerInfo.priceType
        }
      } else if (flage.length) {
        for (let i = index; i < num; i++) {
          this.saleableSkuList[i].resellerId = this.objArr[index].resellerId
          this.saleableSkuList[i].priceType = this.objArr[index].priceType
          this.saleableSkuList[i].sysResellerId = this.objArr[index].sysResellerId
        }
        return this.$message.error('无法同时选择相同的系统分销商')
      } else {
        for (let i = index; i < num; i++) {
          this.saleableSkuList[i].resellerId = val
          this.saleableSkuList[i].priceType = resellerInfo.priceType
          this.saleableSkuList[i].sysResellerId = resellerInfo.sysResellerId
        }
        this.objArr = JSON.parse(JSON.stringify(this.saleableSkuList))
      }
    },
    // 提交分销商
    async saveReseller(isSyncPush) {
      let list = this.saleableSkuList.filter(item => {
        return item.checked
      })
      let flage = list.every(item => {
        if (item.priceType == 1) {
          return item.resellerId && item.supplyPrice && item.defaultStock >= '0'
        } else {
          return item.resellerId && item.supplyPrice && item.retailPrice && item.marketPrice && item.defaultStock >= '0'
        }
      })
      if (!flage) {
        return this.$message.error('所选数据都为必填,还有数据未填！')
      }
      this.errHtml = ''
      const vRes = await GetProhibitedList({ modelCode: this.goodDetailForm.model })
      if (vRes.data.result && vRes.data.result.length) {
        // 判断是不是有少于最低价格
        const sp = list.map(i => i.supplyPrice)
        let flag = false
        for (var i = 0; i < sp.length; i++) {
          if (sp[i] <= vRes.data.result[0].minPrice) {
            flag = true
            break
          }
        }
        if (flag) {
          this.errHtml = `<p>很抱歉，因厂家限制要求，型号<span style="color:red;">${this.goodDetailForm.model}</span>价格不可低于<span style="color:red;">¥${vRes.data.result[0].minPrice}</span>,请修改后重新操作！</p>`
          this.errVisible = true
          return
        }
      }
      list.forEach(val => {
        val.isShelves = isSyncPush ? true : val.isShelves
        val.supplyPrice = Number(val.supplyPrice)
        val.merchantsPrice = Number(val.supplyPrice)
        if (val.priceType == 1) {
          val.retailPrice = Number(val.supplyPrice)
          // val.merchantsPrice = Number(val.supplyPrice)
          val.marketPrice = Number(val.supplyPrice)
        } else {
          val.retailPrice = val.retailPrice ? Number(val.retailPrice) : val.retailPrice
          // val.merchantsPrice = val.merchantsPrice ? Number(val.merchantsPrice) : val.merchantsPrice
          val.marketPrice = val.marketPrice ? Number(val.marketPrice) : val.marketPrice
        }
      })
      let data = {
        isSyncPush: isSyncPush,
        items: list
      }
      CreateOrUpdateMany(data).then(res => {
        if (res.data.success) {
          if (res.data.result) {
            this.$message.success(res.data.result)
            this.$emit("editPriceSuccess")
          } else {
            this.$message.success('保存成功')
            this.$emit("editPriceSuccess")
          }
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    handleUpdateSaleArea() {
      this.updateRes = []
      this.filterData(this.zoneData)
      this.saleableSkuList[this.saleableSkuIndex].saleableAreas = this.updateRes
      this.zoneVisible = false
    },
    filterData(list) {
      list.forEach(i => {
        if (i.stock >= 0 && i.stock !== null && i.stock !== '' && i.stock !== undefined) {
          this.updateRes.push({
            "areaId": i.areaId,
            "areaName": i.areaName,
            "areaFullId": i.areaFullId,
            "stock": i.stock
          })
        }
        if (i.children && i.children.length) {
          this.filterData(i.children)
        }
      })
    },
    // defaultChecked(keys) { // 默认选中
    //   this.$nextTick(() => {
    //     const arr = []
    //     keys.forEach(key => {
    //       if (!this.$refs.tree.getNode(key).childNodes || !this.$refs.tree.getNode(key).childNodes.length) {
    //         arr.push(key)
    //       }
    //     })
    //     this.$refs.tree.setCheckedKeys(arr)
    //   })
    // },
    async setZone(row, index) {
      console.log(row, index, 'row, index')
      this.saleableSkuIndex = index
      this.saleableSkuId = row.saleableSkuId
      this.alreadySetArae = []
      // 基础区域数据没有则重新获取
      if (!this.baseAreaList.length) {
        let res = await GetAreaTree({ MaxLevel: 2 })
        this.baseAreaList = res.data.result.children
        console.log(this.baseAreaList, 'this.baseAreaList')
      }
      // 获取已设置区域库存的区域数据
      let setRes = await GetSaleableAreas({ saleableSkuId: row.saleableSkuId });
      this.alreadySetArae = setRes.data.result
      // 组装数据
      let list = JSON.parse(JSON.stringify(this.baseAreaList))
      const areaList = this.saleableSkuList[this.saleableSkuIndex].saleableAreas
      this.zoneData = this.loopAreaTree(list)
      console.log(this.zoneData, 'this.zoneData')
      this.zoneVisible = true;
    },
    loopAreaTree(treeList, lastFullId) {
      // console.log(areaList,'areaList')
      const newList = treeList.filter(item => {
        let Level = item.data.Level;
        item.Level = Level;
        item.areaId = item.data.Id;
        item.areaName = item.data.Name;
        item.id = item.data.Id;
        item.label = item.data.Name;
        // 设置库存
        let t = this.saleableSkuList[this.saleableSkuIndex].saleableAreas.find(i => i.areaId == item.data.Id)
        console.log(t, 'ttttttttt')
        item.stock = t ? t.stock : null
        // item.disabled = item.stock == 0&&item.areaGroupId>0? true: false
        let nowFullId;
        if (Level == 1) nowFullId = '' + item.data.Id;
        if (Level == 2) nowFullId = [item.data.ParentId, item.data.Id].join(",");
        if (Level == 3) nowFullId = lastFullId + ',' + item.data.Id;
        item.areaFullId = nowFullId;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopAreaTree(item.children, item.areaFullId)
        }
        // filter return true
        return true;
      })
      return newList;
    },
    headerClassName(row, rowIndex) {
      if (row.columnIndex > 0) {
        return 'showRow'
      }
    },
    button2() {
      return (
        <div>
          <span style="margin-right:5px;">属性图</span>
          <el-button on-click={() => this.copyPictureUrl()} type="primary" size="small">向下覆盖</el-button>
        </div>
      )
    },
    button1() {
      return (
        <div>
          <span style="margin-right:5px;">成本价</span>
          <el-button on-click={() => this.copyCostPrice()} type="primary" size="small">向下覆盖</el-button>
        </div>
      )
    },
    button() {
      return (
        <div>
          <span style="margin-right:5px;">商品编码</span>
          <el-button on-click={() => this.copyProductCode()} type="primary" size="small">向下覆盖</el-button>
        </div>
      )
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex;
    },
    select_blur_supplier() {
      this.getSupplierList();
    },
    getSupplierList() {
      let params = {
        SkipCount: 0,
        MaxResultCount: 200
      };
      let that = this;
      GetAllSupplier(params).then((res) => {
        if (res.data.success) {
          that.supplierList = res.data.result.items;
          that.supplierList.unshift({ proSupplierName: '自有商品', id: 0 })
        }
      });
    },
    watchCostPrice(val, data) {
      if (val <= 0) {
        data.costPrice = null
      }
    },
    getAllProperties() {
      GetAllProperties({ PropertyGroupId: this.goodDetailForm.propertyGroupId, showAll: true }).then(res => {
        if (res.data.success) {
          let arr = res.data.result.items || []
          let list = []
          arr.forEach(item => {
            item.propertyValues.forEach(val => {
              list.push({
                propertyId: item.propertyId,
                propertyString: item.propertyName,
                propertyValueId: val.propertyValueId,
                propertyValueString: val.propertyValueString
              })
            })
          })
          this.goodDetailForm.properties = list
        }
      })
    },
    goJumpAttributeTem() {
      if (!this.goodDetailForm.propertyGroupId) {
        return this.$message.warning('请选择属性模板！')
      }
      this.dialogMaintain = true
      // this.$router.push(`/Product/AttributeTemplate/Maintain?groupId=${this.goodDetailForm.propertyGroupId}`)
    },
    getBrandList(key) {
      let obj = {
        IsActive: true,
        SkipCount: 0,
        MaxResultCount: 10000,
      };
      if (key) {
        obj.name = key;
      }
      return new Promise((resolve, reject) => {
        brandGetAll(obj).then((res) => {
          if (res.data.success) {
            this.brandList = res.data.result.items.map((item) => {
              return {
                value: item.name,
                id: item.id,
              };
            });
            resolve(this.brandList);
          } else {
            this.$message.error(res.data.msg);
            reject(res.data.msg);
          }
        });
      });
    },
    async querySearchAsync(queryString, cb) {
      if (queryString) {
        let res = await this.getBrandList(queryString);
        cb(res);
      } else {
        let res = await this.getBrandList();
        cb(res);
      }
    },
    handleSelect(item) {
      this.goodDetailForm.brandId = item.id;
    },
    // spu详情
    getSpuDetail() {
      GetProducDetail({ id: this.spuId }).then(res => {
        if (res.data.success) {
          this.goodDetailForm = { ...res.data.result, categorys: [] } || {}
          this.getProductNavTypeTree(() => {
            // 赋值分类
            this.categoryId = res.data.result.categoryId
            this.getCategoryItems()
          });
          if (this.goodDetailForm.sourceType === 0) {
            this.goodDetailForm.sourceId = 0;
          }
          this.goodDetailForm.introduce = res.data.result.introduce;
          let arr = res.data.result.properties || []
          this.checkList = this.listToTree(arr)
        }
      })
    },
    getCategoryItems() {
      let targId = this.categoryId
      let list = this.productNavTypeTreeList

      this.loopFunc(list)

      let result = []
      let res = this.resList.find(i => i.value === targId)
      result.push(res)
      if (res.pId > 0) {
        let res1 = this.resList.find(i => i.value === res.pId)
        result.push(res1)
        if (res1.pId > 0) {
          let res2 = this.resList.find(i => i.value === res1.pId)
          result.push(res2)
        }
      }
      this.goodDetailForm.categorys = result.reverse().map(i => {
        return {
          categoryId: i.value,
          categoryName: i.label
        }
      })
    },
    loopFunc(list) {
      for (var i = 0; i < list.length; i++) {
        this.resList.push({
          label: list[i].label,
          pId: list[i].pId,
          value: list[i].value
        })
        if (list[i].children && list[i].children.length) {
          this.loopFunc(list[i].children)
        }
      }
    },
    listToTree(arr) {
      let list = []
      arr.forEach(item => {
        let id = item.propertyId
        let index = list.findIndex(val => val.id == item.propertyId)
        if (index > -1) {
          list[index].checkedCities.push(item.propertyValueId)
        } else {
          list.push({
            id: item.propertyId,
            checkedCities: [item.propertyValueId]
          })
        }
      })
      return list
    },
    catchDetailData(data) {
      this.goodDetailForm.introduce = data;
    },
    // getObjByTree1(data, id) {
    //   let result = null
    //   if (!data) return // return; 中断执行
    //   for (let i in data) {
    //     if (result !== null) break
    //     let item = data[i];
    //     if (item.id === id) {
    //       result = item;
    //       break;
    //     } else if (!!item?.childs?.length) {
    //       result = this.getObjByTree(item.childs, id);
    //     }
    //   }
    //   return result;
    // },
    getItemByIdInTree(id, tree) {
      // debugger
      let res = null
      for (let i = 0; i < tree.length; i++) {
        let ele = tree[i]
        if (ele.children && ele.children.length) {
          res = this.getItemByIdInTree(id, ele.children)
        } else {
          ele.value === id ? res = ele : ''
          if (res) break;
        }
      }
      return res
    },
    getPath(data, id) {
      let path = [];
      data.forEach((item, index) => {
        path[0] = { categoryId: item.value, categoryName: item.label };
        if (item.value === id) {
          return path
        }

        if (item.children && item.children.length) {

        }

        if (item.children && item.children.length > 0) {
          item.children.forEach((item1, index1) => {
            if (item1.value === id) {
              // path.push({categoryId:item1.value, categoryName:item1.label})
              // path.unshift({...item1})
              path[1] = { categoryId: item1.value, categoryName: item1.label };
            } else {
              if (item1.children && item1.children.length > 0) {
                item1.children.forEach((item2, index2) => {
                  if (item2.value === id) {
                    // path.push({categoryId:item2.value, categoryName:item2.label});
                    // path.unshift({...item2});
                    path[2] = { categoryId: item2.value, categoryName: item2.label };
                  }
                })
              }
            }
          })
        }

      })
    },

    query(arr, id) {
      let data = [];
      arr.forEach(item => {
        if (item.value === id) {
          data.push(item)
        }
        if (item.children) {
          this.query(item.children, id)
        }
      })
      return data;
    }
    ,
    // 商品类型
    getProductNavTypeTree(callback) {
      let that = this;
      CategoryGetTree({ parentId: 0, isActive: true }).then((res) => {
        that.productNavTypeTreeList = this.loopMenuTree(res.data.result.children);
        // console.log(that.productNavTypeTreeList, 'kkkkk')
        callback && callback()

      });
    },
    loopMenuTree(treeList) {
      const newList = treeList.filter(item => {
        item.value = item.data.Id;
        item.pId = item.data.ParentId
        item.label = item.data.Name;
        delete item.data
        if (!item.children.length) {
          delete item.children
        } else {
          this.loopMenuTree(item.children)
        }
        return true;
      })
      return newList;
    },
    //获取七牛token
    getQiniuToken() {
      var that = this;
      getQiniuToken().then((res) => {
        that.qiniuToken = res.data;
      })
        .catch(() => {
        });
    },
    handleDelPic(item, index) {
      this.$confirm("确认删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      }).then(() => {
        this.deletePicture(item)
        // this.goodDetailForm.pictures.splice(index, 1);
      }).catch(() => {
      })
    },
    handleBusinessPic(file) {
      let that = this;
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils.uploadImgToQiniu(file.raw, qiniuData)
        .then((res) => {
          // let itemPic;
          // if (that.goodDetailForm.pictures[0]) {
          //   itemPic = {
          //     url: res,
          //     type: 1,
          //   };
          // } else {
          //   itemPic = {
          //     url: res,
          //     type: 0,
          //   };
          // }
          // that.goodDetailForm.pictures.push(itemPic);
          that.uploadPicture(res)
        }).catch((err) => {
          that.$message.error(err);
        });
    },
    uploadPicture(url) {
      let data = {
        productId: this.spuId,
        url: url,
        type: 1
      }
      AddPicture(data).then(res => {
        if (res.data.success) {
          this.$message.success('添加成功！')
          this.getSpuDetail()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    deletePicture(item) {
      let data = {
        productId: this.spuId,
        productPictureId: item.id
      }
      DeletePicture(data).then(res => {
        if (res.data.success) {
          this.$message.success('删除成功！')
          this.getSpuDetail()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    updatePicture(item) {
      let data = {
        productId: this.spuId,
        productPictureId: item.id,
        type: item.type == 1 ? 0 : 1
      }
      UpdatePicture(data).then(res => {
        if (res.data.success) {
          this.$message.success('设置成功！')
          this.getSpuDetail()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    // 属性组合
    selectScep() {
      GetProductSkuPreView({ ProductId: this.spuId }).then(res => {
        if (res.data.success) {
          // console.log('resss', res);
          this.dialogCombination = true
          this.skuPreViewList = res.data.result || []
          // return;
          this.$nextTick(() => {
            this.createSkuList.forEach(row => {
              let index = this.skuPreViewList.findIndex(i => {
                return i.speCode === row.speCode
              })
              if (index > -1) {
                // this.$set(this.skuPreViewList[i].items[findTargIndex], 'isCheck', true)
                this.$refs.diaTable.toggleRowSelection(this.skuPreViewList[index])
              }
            })
          })
        }
      })
      // console.log('this.createSkuList', this.createSkuList)
    },
    getPropertyValue(arr) {
      // console.log(arr, 'dddd')
      this.dialogMaintain = false
      this.goodDetailForm.properties = arr
    },
    // 添加/编辑商品
    addOrUpdata() {
      let that = this;
      if (!that.goodDetailForm.categoryId)
        return that.$message.error("请选择商品类型！");
      if (!that.goodDetailForm.name)
        return that.$message.error("请输入商品名称！");
      if (!that.goodDetailForm.model)
        return that.$message.error("请输入商品型号！");
      if (!that.goodDetailForm.brandId)
        return that.$message.error("请选择商品品牌！");
      // if (that.goodDetailForm.sourceType === 1 && that.goodDetailForm.sourceId === null)
      //   return that.$message.error("请选择供应商");
      // if (!that.goodDetailForm.propertyGroupId && that.goodDetailForm.propertyGroupId !== 0)
      //   return that.$message.error("请选择属性模板！");
      if (!that.goodDetailForm.pictures[0])
        return that.$message.error("请上传商品展示图片！");
      if (!that.goodDetailForm.introduce)
        return that.$message.error("请填写商品描述！");
      let pattern = /https?:\/\/?/
      if (pattern.test(that.goodDetailForm.serviceContent)) {
        return that.$message.error('补充说明请勿输入跳转链接')
      }
      let params = JSON.parse(JSON.stringify(that.goodDetailForm));
      if (params.sourceId === null) {
        params.sourceId = 0;
      }
      that.$confirm("确认提交吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      })
        .then(() => {
          ProductUpdate(params).then((res) => {
            if (res.data.success) {
              this.stepIndex = 1
              that.$message.success('编辑成功！');
            } else {
              // that.$message.error(res.data.msg);
            }
          });
          // }
        });
    },
    handleChange(value) {
      this.goodDetailForm.categorys = []
      let { path, pathLabels } = this.$refs['cascader'].getCheckedNodes()[0]
      path.forEach((item, i) => {
        this.goodDetailForm.categorys.push({
          categoryId: item, categoryName: pathLabels[i]
        })
      })
    },
    handleSelectionChange(arr) {
      this.checkedSkuList = arr
    },
    confrimSku() {
      let list = []
      this.checkedSkuList.forEach(item => {
        list.push({
          // "productId": item.productId,
          "speCode": item.speCode,
          "productSpec": item.productSpec,
          "productSpecExt": item.productSpec,
          "propertyJson": item.propertyJson,
          "propertyJsonArr": JSON.parse(item.propertyJson),
          "productCode": "",
          "pictureUrl": this.skuMainpic,
          "costPrice": null,
          "isActive": true,
          "saleableSkuPriceItems": []
        })
      })
      if (!this.createSkuList[0]) {
        this.createSkuList = list
      } else {
        list.forEach(item => {
          item.propertyJsonArr.PropertyList.forEach(val => {
            this.createSkuList.forEach(item2 => {
              item2.propertyJsonArr.PropertyList.forEach(val2 => {
                if (val2.PropertyValueId == val.PropertyValueId) {
                  val.PropertyValueString = val2.PropertyValueString
                }
              })
            })
          })
        })
        this.createSkuList = this.arrayDup(this.createSkuList, list)
      }
      console.log(this.createSkuList, 'this.createSkuList')
      this.dialogCombination = false
    },
    // 处理同一属性名称
    changeInputSpec(spec, value) {
      this.createSkuList.forEach(item => {
        item.propertyJsonArr.PropertyList.forEach(val => {
          if (spec.PropertyValueId == val.PropertyValueId) {
            val.PropertyValueString = value
          }
        })
      })
    },
    // 去重
    arrayDup(arr1, arr2) {
      let list1 = [], list2 = []
      for (let i = 0; i < arr1.length; i++) {
        for (let j = 0; j < arr2.length; j++) {
          if (arr1[i].speCode == arr2[j].speCode) {
            list1.push(arr1[i])
          }
        }
      }
      arr2.forEach(item => {
        let index = arr1.findIndex(i => {
          return i.speCode === item.speCode
        })
        if (index < 0) {
          list2.push(item)
        }
      })
      return list1.concat(list2)
    },
    // 保存sku
    handleSubmitSku() {
      // 校验成本价不能为空
      let elements = document.querySelectorAll('#container .cost-price input');
      for (let el of elements) {
        el.classList.remove("input-err");
      }
      for (let el of elements) {
        if (isNaN(el.valueAsNumber)) {
          el.classList.add("input-err");
          return this.$message.error('成本价不能为空');
        }
      }

      // console.log(this.createSkuList,'createSkuList')
      // let list = this.createSkuList
      let items = JSON.parse(JSON.stringify(this.createSkuList))
      if (items.length) {
        items.forEach(i => {
          i.productSpecExt = ''
          i.propertyJsonArr.PropertyList.forEach(v => {
            i.productSpecExt += `${v.PropertyString}*`
          })
          i.propertyJsonExt = JSON.stringify(i.propertyJsonArr)
          i.saleableSkuItems = []
          i.saleableSkuPriceItems.forEach(s => {
            if (s.priceType == 1) {
              s.retailPrice = s.supplyPrice;
              s.merchantsPrice = s.supplyPrice;
              s.marketPrice = s.supplyPrice;
            }
            i.saleableSkuItems.push({
              "saleableSkuId": s.saleableSkuId,
              "supplyPrice": s.supplyPrice,
              "retailPrice": s.retailPrice,
              "merchantsPrice": s.merchantsPrice,
              "marketPrice": s.marketPrice,
              "isShelves": s.isShelves
            })
          })
        })
      }

      let data = {
        productId: this.spuId,
        items
      }
      BatchCreateAndUpdate(data).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功！')
          this.getSkuList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getSkuList() {
      ProductSkuGetAllNew({ ProductId: this.spuId }).then(res => {
        let list = res.data.result.items || []
        list.forEach(item => {
          item.propertyJsonArr = JSON.parse(item.propertyJsonExt)
        })
        this.createSkuList = list
        this.$nextTick(() => {
          if (this.createSkuList && this.createSkuList.length > 0) {
            this.$refs.isExpand.toggleRowExpansion(this.createSkuList[0], true);
          }
        })
      })
    },
    deleteSku(data, index) {
      // console.log('index', index)
      // return;
      if (data.id) {
        ProductSkuDelete({ ids: [data.id] }).then(res => {
          if (res.data.success) {
            this.getSkuList()
          }
        })
      } else {
        this.createSkuList.splice(index, 1)
      }
    },
    // 图片放大
    handleBigPic(src) {
      this.dialogVisible = true;
      this.dialogImageUrl = src;
    },
    setMain(item, index) {
      let that = this;
      // that.goodDetailForm.pictures.forEach((v, i) => {
      //   if (index == i) {
      //     var arr = [
      //       {
      //         url: that.goodDetailForm.pictures.splice(i, 1)[0].url,
      //         type: 0,
      //       },
      //     ];
      //     that.goodDetailForm.pictures = [
      //       ...arr,
      //       ...that.goodDetailForm.pictures,
      //     ];
      //   }
      // });
      // that.goodDetailForm.pictures.forEach((v, i) => {
      //   if (i > 0) {
      //     v.type = 1;
      //   }
      // });
      that.updatePicture(item)
    },
    handleSkuChange(e, i) {
      // console.log(e,i,'e,i')
      // return false
      let that = this;
      let file = e.target.files[0];
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils.uploadImgToQiniu(file, qiniuData).then((res) => {
        window.document.getElementById("el_upload_input").value = null;
        // i.pictureUrl = res;
        that.$set(i, 'pictureUrl', res)
        // if (i != null) {
        //   that.createSkuList[i].pictureUrl = res;
        // }
      })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    delSkuPic(i) {
      i.pictureUrl = ''
      // this.createSkuList[i].pictureUrl = "";
    },
    copyProductCode() {
      // console.log('cover')
      let productCode = ''
      if (this.createSkuList[0].productCode) {
        productCode = this.createSkuList[0].productCode
        this.createSkuList.forEach(item => {
          item.productCode = productCode
        })
      } else {
        this.$message.warning('请先填写第一行内容！')
      }
    },
    copyCostPrice() {
      let costPrice = ''
      if (this.createSkuList[0].costPrice) {
        costPrice = this.createSkuList[0].costPrice
        this.createSkuList.forEach(item => {
          item.costPrice = costPrice
        })
      } else {
        this.$message.warning('请先填写第一行内容！')
      }
    },
    copyPictureUrl() {
      let pictureUrl = ''
      if (this.createSkuList[0].pictureUrl) {
        pictureUrl = this.createSkuList[0].pictureUrl
        this.createSkuList.forEach(item => {
          item.pictureUrl = pictureUrl
        })
      } else {
        this.$message.warning('请先填写第一行内容！')
      }
    },
  },
};
</script>
<style scoped>
.add_main {}

.flex-wrap {
  display: flex;
  align-items: center;
}

.step-box {
  color: #606266;
  margin-bottom: 15px;
  cursor: pointer;
  padding-bottom: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid #EBEEF5;
}

.mgr20 {
  margin-right: 20px;
}

.stepOn {
  color: #000;
  font-weight: 700;
  position: relative;
}

.stepOn:after {
  content: '';
  width: 40px;
  height: 2px;
  background: #000;
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
}

#allsku /deep/ .showRow {
  display: none;
}

.blue-txt {
  color: #409eff;
}

.el-input,
.el-cascader,
.el-autocomplete {
  width: 300px;
}

.el-textarea {
  width: 500px;
}

/* .el-form {
  padding-left: 20px;
} */

.tab_box {
  padding: 20px;
}

.img_box {
  width: 80px;
  height: 80px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  float: left;
  position: relative;
  margin-right: 10px;
}

.img_box img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.bg_box {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0;
}

.bg_box:hover {
  opacity: 1;
}

.del_box {
  position: absolute;
  top: -10px;
  right: -10px;
  width: 20px;
  height: 20px;
}

.del_box img {
  height: 100%;
  width: 100%;
}

.img-uploader {
  display: inline-block;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
}

.img-uploader:hover {
  border-color: #409eff;
}

.img-uploader .el_upload {
  height: 80px;
  width: 80px;
}

.el-upload img {
  height: 100%;
  width: 100%;
  border-radius: 6px;
}

.avatar-uploader-icon {
  font-size: 24px;
  color: #8c939d;
  width: 80px;
  height: 80px;
  line-height: 80px;
  text-align: center;
}

.avatar {
  width: 80px;
  height: 80px;
  display: block;
}

.set_main {
  position: absolute;
  bottom: -40px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.set-share {
  position: absolute;
  bottom: -70px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.params_box div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
}

.from_tit {
  color: #606266;
  margin-right: 20px;
}

.params_box ul {
  list-style: none;
  margin: 0;
  padding: 0 20px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.params_box ul>li {
  padding: 0 10px;
  color: #fff;
  border-radius: 15px;
  font-size: 14px;
  margin-right: 20px;
}

.el_upload_input {
  height: 100px;
  width: 100px;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 99;
}

.single_up_img {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.el_upload_sku {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el_upload_sku:hover {
  border-color: #409eff;
}

.el_upload_sku:hover .mask {
  opacity: 1;
}

.mask {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  line-height: 178px;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.el-table {
  border: 1px solid #999;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
  flex: 1;
  width: 100%;
  max-width: 100%;
  font-size: 14px;
  color: #606266;
  background-color: #fff;
}

.el-table table {
  width: 100% !important;
  max-width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
}

.el-table thead {
  color: #909399;
  table-layout: fixed;
  border-collapse: separate;
  font-weight: 500;
}

.el-table th,
.el-table tr {
  background: #fff;
}

.el-table .el-table__body td,
.el-table .el-table__header tr th {
  padding: 0;
  background: #f6f7f9;
  border-right: 1px solid #dde5e8;
  border-bottom: 1px solid #dde5e8;
  text-align: center;
  overflow: hidden;
  user-select: none;
  box-sizing: border-box;
  text-overflow: ellipsis;
  vertical-align: middle;
  position: relative;
}

.el-table .el-table__header th:first-child div.cell {
  border-left: 0;
  background: #f6f7f9;
  padding: 7px 8px;
  font-weight: 100;
  font-size: 12px;
  box-sizing: border-box;
  position: relative;
  vertical-align: middle;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
}

.el-table__body,
.el-table__footer,
.el-table__header {
  table-layout: fixed;
  border-collapse: separate;
}

.el-table th,
.el-table tr {
  background-color: #fff;
  box-sizing: border-box;
  text-align: center;
  width: 100px;
  border-right: 1px solid #dfe6ec;
}

.el-table .el-table__body td div.cell {
  font-size: 12px;
  padding: 9px 8px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  line-height: 23px;
}

.cell .el-input {
  width: 100%;
}

.avatar-box {
  height: 100px;
  width: 100px;
}

.up_img {
  display: flex;
  justify-content: center;
  align-items: center;
}

.sbmit_info {
  padding: 20px;
  display: flex;
  justify-content: center;
  width: 100%;
}

#container /deep/ .cost-price input.input-err {
  border: #F56C6C solid 1px;
}
</style>
